import React, { useState, useEffect } from "react";

const COLORS = ["bg-red-500", "bg-blue-500", "bg-green-500", "bg-yellow-500"];

export default function SimonSays() {
  const [seq, setSeq] = useState([]);
  const [playerSeq, setPlayerSeq] = useState([]);
  const [activeBtn, setActiveBtn] = useState(null);
  const [status, setStatus] = useState("Press Start");
  const [isPlayerTurn, setIsPlayerTurn] = useState(false);

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  const startNextLevel = async (newSeq) => {
    setIsPlayerTurn(false);
    setStatus(`Level ${newSeq.length} - Watch!`);
    await sleep(1000);
    for (let colorIdx of newSeq) {
      setActiveBtn(colorIdx);
      await sleep(400);
      setActiveBtn(null);
      await sleep(200);
    }
    setIsPlayerTurn(true);
    setStatus("Your Turn!");
  };

  const handlePress = (idx) => {
    if (!isPlayerTurn) return;
    setActiveBtn(idx);
    setTimeout(() => setActiveBtn(null), 200);

    const newPlayerSeq = [...playerSeq, idx];
    setPlayerSeq(newPlayerSeq);

    if (
      newPlayerSeq[newPlayerSeq.length - 1] !== seq[newPlayerSeq.length - 1]
    ) {
      setStatus(`Game Over! Reached Level ${seq.length}`);
      setSeq([]);
      setIsPlayerTurn(false);
      return;
    }

    if (newPlayerSeq.length === seq.length) {
      const nextSeq = [...seq, Math.floor(Math.random() * 4)];
      setSeq(nextSeq);
      setPlayerSeq([]);
      setTimeout(() => startNextLevel(nextSeq), 1000);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col items-center justify-center">
      <h1 className="text-3xl font-bold text-white mb-6">{status}</h1>
      <div className="grid grid-cols-2 gap-4 bg-slate-800 p-6 rounded-full shadow-2xl">
        {COLORS.map((col, i) => (
          <button
            key={i}
            onClick={() => handlePress(i)}
            className={`w-32 h-32 rounded-lg transition-all duration-200 ${col} ${activeBtn === i ? "brightness-150 scale-95 shadow-[0_0_30px_rgba(255,255,255,0.8)]" : "brightness-50"}`}
          />
        ))}
      </div>
      {seq.length === 0 && (
        <button
          onClick={() => {
            const s = [Math.floor(Math.random() * 4)];
            setSeq(s);
            setPlayerSeq([]);
            startNextLevel(s);
          }}
          className="mt-10 px-8 py-3 bg-white text-black font-bold rounded-xl"
        >
          Start Game
        </button>
      )}
    </div>
  );
}
